import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Zap, TrendingUp, ArrowUpRight } from 'lucide-react';

const ProjectGallery = () => {
  const projects = [
    { id: 1, title: 'The Sky-Villa Grid', tag: 'Residential Estate', location: 'California, USA', capacity: '16.0 kW', savings: '$2,400/year', image: 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?w=600&auto=format&fit=crop&q=80', color: 'text-[#10B981]' },
    { id: 2, title: 'Zenith Logistics Hub', tag: 'Industrial Complex', location: 'Texas, USA', capacity: '380.0 kW', savings: '$42,000/year', image: 'https://images.unsplash.com/photo-1613665813446-82a78c468a1d?w=600&auto=format&fit=crop&q=80', color: 'text-[#0D9488]' },
    { id: 3, title: 'GreenField Organic Fields', tag: 'Agri-tech Grid', location: 'Florida, USA', capacity: '120.0 kW', savings: '$12,600/year', image: 'https://images.unsplash.com/photo-1548345680-f5475ea5df84?w=600&auto=format&fit=crop&q=80', color: 'text-[#10B981]' },
  ];

  return (
    <section id="projects" className="py-32 bg-slate-50 border-t border-slate-100 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        
        {/* HEADER */}
        <div className="text-center max-w-2xl mx-auto mb-20">
          <span className="text-xs font-bold tracking-widest text-[#0D9488] uppercase">Global Portfolio Metrics</span>
          <h2 className="text-3xl md:text-5xl font-black text-[#0F172A] tracking-tight mt-2">
            Completed <span className="bg-gradient-to-r from-[#10B981] to-[#0D9488] bg-clip-text text-transparent">Projects</span>
          </h2>
        </div>

        {/* GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, margin: "-50px" }}
              transition={{ duration: 0.6, delay: index * 0.05 }}
              whileHover={{ y: -6 }}
              className="bg-white rounded-3xl overflow-hidden border border-slate-200/60 shadow-sm hover:shadow-2xl transition-all duration-400 group flex flex-col justify-between"
            >
              <div>
                <div className="h-60 overflow-hidden relative">
                  <img src={project.image} alt={project.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <div className="absolute top-4 right-4 w-9 h-9 bg-white/90 backdrop-blur-md rounded-xl flex items-center justify-center text-[#0F172A] opacity-0 group-hover:opacity-100 transition-opacity"><ArrowUpRight className="w-4 h-4 stroke-[2.5]" /></div>
                </div>
                <div className="p-8 space-y-4">
                  <div className={`text-[10px] uppercase tracking-widest font-black ${project.color}`}>{project.tag}</div>
                  <h3 className="text-xl font-extrabold text-[#0F172A] tracking-tight group-hover:text-[#0D9488] transition-colors">{project.title}</h3>
                  <div className="pt-2 grid grid-cols-1 gap-2.5 border-t border-slate-100">
                    <div className="flex items-center gap-3 text-slate-500 font-medium text-xs sm:text-sm">
                      <MapPin className="w-4 h-4 text-slate-400" /> <span>{project.location}</span>
                    </div>
                    <div className="flex items-center gap-3 text-slate-500 font-medium text-xs sm:text-sm">
                      <Zap className="w-4 h-4 text-[#10B981]" /> <span>Capacity: <strong className="text-slate-700">{project.capacity}</strong></span>
                    </div>
                    <div className="flex items-center gap-3 text-slate-500 font-medium text-xs sm:text-sm">
                      <TrendingUp className="w-4 h-4 text-[#0D9488]" /> <span>Savings: <strong className="text-slate-700">{project.savings}</strong></span>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ProjectGallery;